import React, {useContext, useState} from 'react'
import { StateContext } from '../../context/GlobalState.jsx'
import {Link} from 'react-router-dom'
import {Modal, Button} from "react-bootstrap";
import {GetText} from "../../context/text.js";


function ProductItem({product}) {
    // consuming contexts
    const {addToCart, favoriteItems, addToFavorite, removeFromFavorite, courseUSD} = useContext(StateContext);
    let {lang} = useContext(StateContext);

    let text = GetText();

    // Cart button display
    function cartButton() {
        return (
            <button onClick={() => addToCart(product)} className="add-cart-btn">{text.ProductItem.cartButton}</button>
        ) 
    }

    // determine which Favorite button to display
    function favoriteButton() {
        // check which product is already favorited
        const alreadyFavorited = favoriteItems.some(item => item.ID===product.ID)
        
        if(alreadyFavorited){
            return (
                <i onClick={() => removeFromFavorite(product.id)} className="ri-heart-fill favorite favorite-btn"></i>
            ) 
        }else{
            return (
                <i onClick={() => addToFavorite(product)} className="ri-heart-line favorite favorite-btn"></i>
            ) 
        }
    }


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    // render JSX
    return (
        <div key={product.ID} className="product-card">
            <div className="product-image">
                {/* product image */}
                { product.PHOTO == "" ? <img className="photo-detail" onClick={handleShow} src="https://zapauto.com.ua/backend/public/images/logo-zapauto.png"  title={product.NAME_UA} alt="product" /> : <img className="photo-detail" onClick={handleShow} src={product.PHOTO.replace("../", "https://zapauto.com.ua/")}  title={product.NAME_UA} alt="product" /> }

                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{product.MANUFACTURER} | {product.PART_NUMBER}</Modal.Title>
                    </Modal.Header>
                    { product.PHOTO == "" ? <Modal.Body><img className="photo-detail photoZoom" src="https://zapauto.com.ua/backend/public/images/logo-zapauto.png" title={product.NAME_UA} alt="product" /></Modal.Body> : <Modal.Body><img className="photo-detail photoZoom" src={product.PHOTO.replace("../", "https://zapauto.com.ua/")} title={product.NAME_UA} alt="product" /></Modal.Body> }

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {text.ProductDetail.close}
                        </Button>
                    </Modal.Footer>
                </Modal>


            </div>
            <div className="product-info">
                {/* product title */}
                <h5> {product.MANUFACTURER} | {product.PART_NUMBER}</h5>

                { lang === "ua" ? <h5><b>{product.NAME_UA}</b></h5> : ""}
                { lang === "ru" ? <h5><b>{product.NAME_RU}</b></h5> : ""}
                { lang === "en" ? <h5><b>{product.NAME_EN}</b></h5> : ""}


                {/* product price */}
                { lang === "ua" ? <h6 style={{ color: 'green', fontWeight: 'bold' }} >{product.PRICE_USD * courseUSD} грн </h6> : ""}
                { lang === "ru" ? <h6 style={{ color: 'green', fontWeight: 'bold' }}>{product.PRICE_USD * courseUSD} грн </h6> : ""}
                { lang === "en" ? <h6 style={{ color: 'green', fontWeight: 'bold' }}>{product.PRICE_USD * courseUSD} UAH </h6> : ""}

                
                {/* favorite button */}
                { favoriteButton() }
                
                {/* cart button */}
                { cartButton() }

                {/* detail button */}

                { lang === "ua" ? <Link title={product.NAME_UA} to={`/product/${product.PART_NUMBER}`}>
                    <button className="view-detail-btn">
                        {text.ProductItem.detailButton}
                    </button>
                </Link>  : ""}
                { lang === "ru" ? <Link title={product.NAME_RU} to={`/product/${product.PART_NUMBER}`}>
                    <button className="view-detail-btn">
                        {text.ProductItem.detailButton}
                    </button>
                </Link>  : ""}
                { lang === "en" ? <Link title={product.NAME_EN} to={`/product/${product.PART_NUMBER}`}>
                    <button className="view-detail-btn">
                        {text.ProductItem.detailButton}
                    </button>
                </Link>  : ""}


            </div>
        </div>
    )
}

export default ProductItem
